import {
  COMPANY_CONTACT_TYPE,
  PROFILE_CONTACT_TYPE,
} from '../../../constants/contact'

export const PROFILE_CONTACTS_WIDGET_MAX = 20

export const PROFILE_CONTACTS_WIDGET_ADD_TYPES = [
  PROFILE_CONTACT_TYPE.PHONE,
  PROFILE_CONTACT_TYPE.EMAIL,
  PROFILE_CONTACT_TYPE.WEBSITE,
]

// Backend wording differs: login contacts of regular users fail with spaces,
// additional emails of external contacts/providers with underscores.
export const PROFILE_CONTACTS_WIDGET_SERVER_ERROR_NOTIFICATION_KEY = {
  Email_is_occupied_within_the_Uk: 'ServerError.EmailAlreadyExistsKey',
  'Email is occupied within the Uk': 'ServerError.EmailAlreadyExistsKey',
  'Phone is occupied within the Uk': 'ServerError.PhoneAlreadyExistsKey',
}

export const PROFILE_CONTACTS_WIDGET_QA_NAME = {
  addButton: 'profileContactsWidgetAddButton',
  cancelButton: 'profileContactsWidgetCancelButton',
  copyButton: 'profileContactsWidgetCopyButton',
  deleteButton: 'profileContactsWidgetDeleteButton',
  editButton: 'profileContactsWidgetEditButton',
  emailButton: 'profileContactsWidgetEmailButton',
  saveButton: 'profileContactsWidgetSaveButton',
}

export const COMPANY_CONTACT_TYPE_CONFIG = {
  [COMPANY_CONTACT_TYPE.EMAIL]: {
    dropdownLabelKey: 'ProfileContactsWidget.DropdownAddEntityEmailKey',
    isEmail: true,
    labelKey: 'ProfileContactsWidget.LabelEmailKey',
    order: 0,
    placeholderKey: 'ProfileContactsWidget.PlaceholderEmailKey',
  },
  [COMPANY_CONTACT_TYPE.EMERGENCY_PHONE]: {
    dropdownLabelKey:
      'ProfileContactsWidget.DropdownAddEntityEmergencyPhoneKey',
    isPhone: true,
    labelKey: 'ProfileContactsWidget.LabelEmergencyPhoneKey',
    order: 0,
  },
  [COMPANY_CONTACT_TYPE.PHONE]: {
    dropdownLabelKey: 'ProfileContactsWidget.DropdownAddEntityPhoneKey',
    isPhone: true,
    labelKey: 'ProfileContactsWidget.LabelPhoneKey',
    order: 0,
  },
  [COMPANY_CONTACT_TYPE.WEBSITE]: {
    dropdownLabelKey: 'ProfileContactsWidget.DropdownAddEntityWebsiteKey',
    isWebsite: true,
    labelKey: 'ProfileContactsWidget.LabelWebsiteKey',
    order: 0,
    placeholderKey: 'ProfileContactsWidget.PlaceholderWebsiteKey',
  },
}

export const PROFILE_CONTACT_TYPE_CONFIG = {
  [PROFILE_CONTACT_TYPE.ADDRESS]: {
    labelKey: 'ProfileContactsWidget.LabelAddressKey',
    order: 8,
  },
  [PROFILE_CONTACT_TYPE.AUTH_EMAIL]: {
    infoTooltipKey: 'ProfileContactsWidget.MainEmailTooltipKey',
    isEmail: true,
    labelKey: 'ProfileContactsWidget.MainEmailLabelKey',
    noValueTextKey: 'ProfileContactsWidget.NoMainEmailKey',
    order: 0,
    placeholderKey: 'ProfileContactsWidget.PlaceholderEmailKey',
  },
  [PROFILE_CONTACT_TYPE.AUTH_PHONE]: {
    infoTooltipKey: 'ProfileContactsWidget.MainTelephoneTooltipKey',
    isPhone: true,
    labelKey: 'ProfileContactsWidget.MainTelephoneLabelKey',
    noValueTextKey: 'ProfileContactsWidget.NoMainTelephoneKey',
    order: 1,
  },
  [PROFILE_CONTACT_TYPE.EMAIL]: {
    dropdownLabelKey: 'ProfileContactsWidget.AdditionalEmailLabelKey',
    isEmail: true,
    labelKey: 'ProfileContactsWidget.AdditionalEmailLabelKey',
    order: 2,
    placeholderKey: 'ProfileContactsWidget.PlaceholderEmailKey',
  },
  [PROFILE_CONTACT_TYPE.EMERGENCY_PHONE]: {
    isPhone: true,
    labelKey: 'ProfileContactsWidget.LabelEmergencyPhoneKey',
    order: 6,
  },
  [PROFILE_CONTACT_TYPE.ORDER_EMAIL]: {
    isEmail: true,
    labelKey: 'ProfileContactsWidget.LabelOrderEmailKey',
    order: 7,
  },
  [PROFILE_CONTACT_TYPE.ORDER_PHONE]: {
    isPhone: true,
    labelKey: 'ProfileContactsWidget.LabelOrderPhoneKey',
    order: 5,
  },
  [PROFILE_CONTACT_TYPE.PHONE]: {
    dropdownLabelKey: 'ProfileContactsWidget.AdditionalTelephoneLabelKey',
    isPhone: true,
    labelKey: 'ProfileContactsWidget.AdditionalTelephoneLabelKey',
    order: 3,
  },
  [PROFILE_CONTACT_TYPE.WEBSITE]: {
    dropdownLabelKey: 'ProfileContactsWidget.LabelWebsiteKey',
    isWebsite: true,
    labelKey: 'ProfileContactsWidget.LabelWebsiteKey',
    order: 4,
    placeholderKey: 'ProfileContactsWidget.PlaceholderWebsiteKey',
  },
  [PROFILE_CONTACT_TYPE.WORKING_HOURS]: {
    labelKey: 'ProfileContactsWidget.LabelWorkingHoursKey',
    order: 9,
  },
}

// External contacts have no login contacts and keep one additional email.
export const EXTERNAL_CONTACT_CONTACT_TYPE_CONFIG = {
  [PROFILE_CONTACT_TYPE.EMAIL]: {
    ...PROFILE_CONTACT_TYPE_CONFIG[PROFILE_CONTACT_TYPE.EMAIL],
    isUnique: true,
  },
  [PROFILE_CONTACT_TYPE.PHONE]:
    PROFILE_CONTACT_TYPE_CONFIG[PROFILE_CONTACT_TYPE.PHONE],
  [PROFILE_CONTACT_TYPE.WEBSITE]:
    PROFILE_CONTACT_TYPE_CONFIG[PROFILE_CONTACT_TYPE.WEBSITE],
}

// Providers keep at most one contact per type (enforced server-side), so every
// entry is unique and the dropdown reuses the row labels. The provider "Main
// email" is stored as the plain EMAIL type, not AUTH_EMAIL, and is not a portal
// login, so it has its own label and no login tooltip.
// The legacy marketplace ORDER_EMAIL / ORDER_PHONE types stay in the backend
// model (ETL) but are not shown here.
export const PROVIDER_CONTACT_TYPE_CONFIG = {
  [PROFILE_CONTACT_TYPE.EMAIL]: {
    dropdownLabelKey: 'ProfileContactsWidget.ProviderEmailLabelKey',
    isEmail: true,
    isUnique: true,
    labelKey: 'ProfileContactsWidget.ProviderEmailLabelKey',
    noValueTextKey: 'ProfileContactsWidget.NoMainEmailKey',
    order: 0,
    placeholderKey: 'ProfileContactsWidget.PlaceholderEmailKey',
  },
  [PROFILE_CONTACT_TYPE.PHONE]: {
    dropdownLabelKey: 'ProfileContactsWidget.LabelPhoneKey',
    isPhone: true,
    isUnique: true,
    labelKey: 'ProfileContactsWidget.LabelPhoneKey',
    order: 1,
  },
  [PROFILE_CONTACT_TYPE.WEBSITE]: {
    dropdownLabelKey: 'ProfileContactsWidget.LabelWebsiteKey',
    isUnique: true,
    isWebsite: true,
    labelKey: 'ProfileContactsWidget.LabelWebsiteKey',
    order: 2,
    placeholderKey: 'ProfileContactsWidget.PlaceholderWebsiteKey',
  },
}
